// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3O6Lf","tab":"ProcedureTabs_tab__ch0SL"};